import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/sass-template/content/images/Search.svg'


const _withScopeId = n => (_pushScopeId("data-v-ad6eafd8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mb-4" }
const _hoisted_2 = { class: "mb-3 carouselWrapper" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["src"]
const _hoisted_5 = ["onClick", "src"]
const _hoisted_6 = {
  key: 2,
  class: "overlay"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Magnifying Glass",
  class: "magnify-icon"
}, null, -1))
const _hoisted_8 = [
  _hoisted_7
]

import { computed, ref } from 'vue';
import { Swiper, SwiperSlide } from 'swiper/vue/swiper-vue';
import { Splide, SplideSlide } from '@splidejs/vue-splide';
import { Lazy, Mousewheel, Navigation } from 'swiper';
import DriveMediaViewSlide from '@/modules/drive/components/desktop/mediaview/DriveMediaViewSlide.vue';
import { useDriveStore } from '@/modules/drive/store/driveStore';
import { IMedia } from '@/types/interfaces';
import { MEDIA_TYPES, PHOTO_VIEW_TYPE } from '@/types/enums';
import { lowResUrlByViewType } from '@/helpers/lowResPhotoUrl';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const driveStore = useDriveStore();
const swiperInstance = ref();
const splideInstance = ref();
const initialSlide = ref(0);
const currentMedia = ref(0);
const pauseVideo = ref(false);

const mediaList = computed(() => driveStore.currentCase.photos);
const onSwiper = (swiper) => {
  swiperInstance.value = swiper;
  const startMediaId = driveStore.appPhotoViewMedia?.contentId;
  let indexToGo = 0;
  if (startMediaId) {
    indexToGo = mediaList.value.map((el) => (el as IMedia)?.contentId).indexOf(startMediaId);
  }
  initialSlide.value = indexToGo;
  swiper.slideTo(indexToGo, 0, false);
};
const modules = [Mousewheel, Lazy, Navigation];

const onSlideChange = (swiper) => {
  pauseVideo.value = true;
  const mediaType = (mediaList?.value[swiper.activeIndex] as IMedia)?.type;

  const mediaId = mediaList?.value[swiper.activeIndex]?.id;
  if (!mediaId || !mediaType) return;
  currentMedia.value = swiper.activeIndex;
  splideInstance.value.go(swiper.activeIndex);
};

const onThumbSelect = (index: number) => {
  initialSlide.value = index;
  currentMedia.value = index;
  swiperInstance.value.slideTo(index, 0, false);
};

const onSlideOpen = () => {
  driveStore.appPhotoViewMedia = mediaList?.value[currentMedia.value] as IMedia;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Swiper), {
      navigation: "",
      "initial-slide": initialSlide.value,
      "edge-swipe-threshold": 50,
      "long-swipe-ratio": 1.5,
      "slides-per-view": 1,
      "space-between": 0,
      "preload-images": false,
      lazy: true,
      modules: modules,
      onSwiper: onSwiper,
      onSlideChange: onSlideChange,
      onClick: onSlideOpen,
      class: "custom-slide"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(mediaList), (media) => {
          return (_openBlock(), _createBlock(_unref(SwiperSlide), {
            key: media.contentId
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(DriveMediaViewSlide, {
                  media: media!,
                  currentMedia: _unref(driveStore).appPhotoViewMedia,
                  pauseVideo: pauseVideo.value,
                  onIfVideoPaused: _cache[0] || (_cache[0] = ($event: any) => (pauseVideo.value = false)),
                  zoomable: false,
                  showVideoPlayer: false
                }, null, 8, ["media", "currentMedia", "pauseVideo"])
              ])
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    }, 8, ["initial-slide", "long-swipe-ratio"]),
    _createVNode(_unref(Splide), {
      ref: (_value, _refs) => {
        _refs['splideInstance'] = _value
        splideInstance.value = _value
      },
      options: { autoWidth: true, fixedHeight: '80px', arrows: false, pagination: false, gap: '10px' }
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(driveStore).currentCase.photos, (media, index) => {
          return (_openBlock(), _createBlock(_unref(SplideSlide), {
            key: media.id,
            class: "thumbnail"
          }, {
            default: _withCtx(() => [
              (media.type === _unref(MEDIA_TYPES).VIDEO)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    onClick: ($event: any) => (onThumbSelect(index)),
                    class: "selected-thumbnail"
                  }, [
                    _createElementVNode("img", {
                      src: _unref(lowResUrlByViewType)(media, _unref(PHOTO_VIEW_TYPE).THUMB),
                      alt: "case photo"
                    }, null, 8, _hoisted_4)
                  ], 8, _hoisted_3))
                : (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    onClick: ($event: any) => (onThumbSelect(index)),
                    src: _unref(lowResUrlByViewType)(media, _unref(PHOTO_VIEW_TYPE).HMED),
                    alt: "case photo",
                    class: "img-responsive"
                  }, null, 8, _hoisted_5)),
              (index === currentMedia.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    }, 512)
  ]))
}
}

})